import debounce from 'lodash/debounce';
import find from 'lodash/find';

export default {
    methods: {
        resolveFilters() {
            this.filters.forEach((filter) => {
                const param = this.$route.query[filter.name];
                if (param) {
                    if (filter.type === 'string') {
                        this[filter.name] = param;
                    } else if (filter.type === 'select') {
                        let option;
                        if (filter.valueType === 'int') {
                            option = find(filter.options, {value: parseInt(param)});
                        } else {
                            option = find(filter.options, {value: param});
                        }
                        if (option) {
                            this[filter.name] = option;
                        }
                    }
                }
            });
        },
        filterResults: debounce(function () {
            this.$store.commit(this.clearAction);

            if (this.page !== 1) {
                this.$router.replace({
                    name: this.routeName,
                    query: {p: 1}
                });
            } else {
                this.$wait.start(this.loaderName);
                const query = {
                    p: 1
                };
                this.filters.forEach((filter) => {
                    const filterField = this[filter.name];

                    if (filter.type === 'string') {
                        query[filter.name] = filterField;
                    } else if (filter.type === 'select' && filterField) {
                        query[filter.name] = filterField.value;
                    }
                });

                this.$router.replace({
                    name: this.routeName,
                    query: query
                });
            }
        }, 500),
    }
}
